import React from "react"
import { useIntl, defineMessages } from "react-intl"
import { fieldPropTypes } from "redux-form"
import { KeyboardDatePicker } from "@material-ui/pickers"
import moment from "moment"

const messages = defineMessages({
  outOfBoundaries: {
    id: "form.date.out.of.boundaries",
    defaultMessage:
      "Invalid date. The date should be between {minDate} and {maxDate}"
  }
})

export default function FieldDatePicker(props) {
  const {
    input: { onBlur, value, ...inputProps },
    ...others
  } = props
  const { minDate, maxDate } = others

  const { formatMessage: format } = useIntl()

  const onChange = (date) => {
    if (Date.parse(date)) {
      inputProps.onChange(moment(date).toISOString())
    } else {
      inputProps.onChange(null)
    }

    // Since the date selector modal takes the focus off of the input,
    // the best way to track "Losing focus" is value change
    onBlur()
  }

  const toValue = () => {
    return value ? moment(new Date(value)).toISOString() : null
  }

  const toParsableDate = (date, orDefault) => {
    const m = moment(date, "DD/MM/YYYY")
    if (m.isValid()) {
      return m.toISOString()
    }
    return orDefault
  }

  const minDateProp = toParsableDate(minDate, "1900-01-01")
  const maxDateProp = toParsableDate(maxDate, "2100-12-31")
  const outOfBoundaries = format(messages.outOfBoundaries, {
    minDate: moment(minDateProp).format("L"),
    maxDate: moment(maxDateProp).format("L")
  })

  return (
    <KeyboardDatePicker
      autoOk
      {...others}
      {...inputProps}
      width="100%"
      variant="inline"
      inputVariant="outlined"
      size="small"
      format="L"
      mask="__/__/____"
      value={toValue()}
      onChange={onChange}
      minDate={minDateProp}
      minDateMessage={outOfBoundaries}
      maxDate={maxDateProp}
      maxDateMessage={outOfBoundaries}
    />
  )
}

FieldDatePicker.propTypes = {
  ...fieldPropTypes
}
